import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPatch, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const TeamService = {
  async createTeam(team: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`team/create`, team);
  },

  async getTeamList(campaignId: string): AxiosUtilsType {
    return await axiosGet(`team/campaign?id=${campaignId}`);
  },

  async getTeamDetails(selectedRowId: string): AxiosUtilsType {
    return await axiosGet(`team/list/${selectedRowId}`);
  },

  async updateTeam(selectedRowId: string, team: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`team/list/${selectedRowId}`, team);
  },

  async deleteTeam(selectedRowId: string, team: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPatch(`team/list/${selectedRowId}`, team);
  },

  async updateAllocateRewards(team: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`team/allocate/reward`, team);
  },

  async teamInvite(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`team/invitation`, payload);
  },
};
export default TeamService;
